import { setPageStateById } from '@/contexts/PageContext/PageContext';

export const setShowSuperSearchBar = (setState: setPageStateById) => (value: boolean) => {
  setState('SET_SHOW_SUPER_SEARCH_BAR', (s) => {
    return {
      ...s,
      showSuperSearchBar: value,
    };
  });
};
